const supportedWebsites = ['go.jaarbeurs.nl']

export class IframeResizeModule {
    initialize() {
        // window.addEventListener('load', () => {
        // Create browser compatible event handler.
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
        // Listen for a message from the iframe.
        const iframes = document.querySelectorAll(supportedWebsites.map(website => `iframe[src*="${website}"]`));

        if (iframes) {
            iframes.forEach((iframe) => {
                console.log('iframe', iframe);
                eventer(messageEvent, function (e) {
                    if (isNaN(e.data)) return;
                    iframe.style.height = e.data + 'px';
                }, false);
            });
        }
        // });
    }
}